var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"sentry-test-button",on:{"click":_vm.throwDummyError}},[_vm._v(" Test Sentry ")])}
var staticRenderFns = []

export { render, staticRenderFns }